import React from 'react';
import styled from 'styled-components';
import MapImg from '../assets/images/map.png';
import PText from './PText';

const MapStyles = styled.div`
  background: url(${MapImg}) no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 400px;
  .container {
    position: relative;
    min-height: 400px;
  }
  .map__card {
    position: absolute;
    right: 10%;
    bottom: 10%;
    padding: 2rem;
    background: var(--deep-dark);
    width: 100%;
    max-width: 300px;
    border-radius: 12px;
  }
  .map__card__heading {
    font-size: 3rem;
    margin-bottom: 1rem;
  }
  .map__card__link {
    display: inline-block;
    font-size: 1.6rem;
    margin-top: 3rem;
    text-decoration: underline;
  }
  @media only screen and (max-width: 768px) {
    background-position: 80% center;
  }
  @media only screen and (max-width: 400px) {
    .map__card {
      max-width: none;
      right: auto;
    }
  }
`;

export default function Map() {
  return (
    <MapStyles>
      <div className="container">
        <div className="map__card">
          <h3 className="map__card__heading">Here is me</h3>
          <PText>Vil-Potlod, Indore, Madhya Pradesh</PText>
          <a
            className="map__card__link"
            href="https://www.google.com/maps/place/ARUN+CHOUDHARY+-+HOUSE+%F0%9F%8F%A1/@22.9983696,75.6953031,17z/data=!3m1!4b1!4m19!1m13!4m12!1m3!2m2!1d75.7081659!2d22.9839374!1m6!1m2!1s0x3963a76787cc5e3d:0xb6a3f08d9d07319!2sPotlod,+Madhya+Pradesh+453551,+India!2m2!1d75.7080727!2d22.9837326!3e0!3m4!1s0x3963a74d00378c9b:0xaee76c5db59b2353!8m2!3d22.9983696!4d75.6974918"
            target="_blank"
            rel="noreferrer"
          >
            Open in google map
          </a>
        </div>
      </div>
      {/* <img src={MapImg} alt="Map" /> */}
    </MapStyles>
  );
}
